import { PaletteOptions } from '@mui/material/styles';

export interface ColorSet {
  id: string;
  name: string;
  palette: PaletteOptions;
  thumbnail: string;
}

export const COLOR_SETS: ColorSet[] = [
  {
    id: 'modern',
    name: '모던한',
    thumbnail: '#1A237E',
    palette: {
      primary: { main: '#1A237E' },
      secondary: { main: '#3949AB' },
      background: { default: '#E8EAF6', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'dark',
    name: '차분한',
    thumbnail: '#455A64',
    palette: {
      primary: { main: '#455A64' },
      secondary: { main: '#78909C' },
      background: { default: '#ECEFF1', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'vivid',
    name: '화려한',
    thumbnail: '#FF6F61',
    palette: {
      primary: { main: '#FF6F61' },
      secondary: { main: '#f69990' },
      background: { default: '#F7CAC9', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'elegant',
    name: '세련된',
    thumbnail: '#0077BE',
    palette: {
      primary: { main: '#0077BE' },
      secondary: { main: '#72C3DC' },
      background: { default: '#E6F3F7', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'clean',
    name: '깔끔한',
    thumbnail: '#2E7D32',
    palette: {
      primary: { main: '#2E7D32' },
      secondary: { main: '#81C784' },
      background: { default: '#E8F5E9', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'cool',
    name: '시원한',
    thumbnail: '#7B1FA2',
    palette: {
      primary: { main: '#7B1FA2' },
      secondary: { main: '#BA68C8' },
      background: { default: '#F3E5F5', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'warm',
    name: '따뜻한',
    thumbnail: '#FF8F00',
    palette: {
      primary: { main: '#FF8F00' },
      secondary: { main: '#FFB74D' },
      background: { default: '#FFF3E0', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'luxurious',
    name: '고급스러운',
    thumbnail: '#D81B60',
    palette: {
      primary: { main: '#D81B60' },
      secondary: { main: '#FF4081' },
      background: { default: '#FCE4EC', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'classic',
    name: '클래식',
    thumbnail: '#00897B',
    palette: {
      primary: { main: '#00897B' },
      secondary: { main: '#4DB6AC' },
      background: { default: '#E0F2F1', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'bright',
    name: '밝은',
    thumbnail: '#C62828',
    palette: {
      primary: { main: '#C62828' },
      secondary: { main: '#EF5350' },
      background: { default: '#FFEBEE', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'cozy',
    name: '포근한',
    thumbnail: '#FFCCBC',
    palette: {
      primary: { main: '#FF7043' },
      secondary: { main: '#FFAB91' },
      background: { default: '#FFF3E0', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'nature',
    name: '자연스러운',
    thumbnail: '#558B2F',
    palette: {
      primary: { main: '#558B2F' },
      secondary: { main: '#7CB342' },
      background: { default: '#F1F8E9', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'gentle',
    name: '부드러운',
    thumbnail: '#00ACC1',
    palette: {
      primary: { main: '#00ACC1' },
      secondary: { main: '#26C6DA' },
      background: { default: '#E0F7FA', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'peaceful',
    name: '평화로운',
    thumbnail: '#039BE5',
    palette: {
      primary: { main: '#039BE5' },
      secondary: { main: '#29B6F6' },
      background: { default: '#E1F5FE', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  },
  {
    id: 'golden',
    name: '황금빛',
    thumbnail: '#FFB300',
    palette: {
      primary: { main: '#FFB300' },
      secondary: { main: '#FFD54F' },
      background: { default: '#FFF8E1', paper: '#FFFFFF' },
      text: { primary: '#37474F' }
    }
  }
];
